<div class="trailer-card">
  @if (request.trailerLoads.length > 0 && showLoad(request.trailerLoads[0])) {
<div class="grid-container">
    <div class="direction">
      <div>{{getLoadDirection(0)}}</div>
      @if (request.trailerLoads[0].hasUnplannedLoad) {
<div class="text-warning fst-italic">
        *
        {{localize(langSection.TrailerCard, langText.NotPlanned)}}
      </div>
}
    </div>
    <div class="card" [ngClass]="{'unplanned': request.trailerLoads[0].hasUnplannedLoad, 'bobtail': request.trailerLoads[0].isBobtail}">
      <div class="topcols">
        <div class="trailer-number">
          @if (!request.trailerLoads[0].isBobtail) {
<p>
            <span class="number">
              {{request.trailerLoads[0].trailerInfo.trailerNumber}}
            </span>
            <span class="length">
              {{request.trailerLoads[0].trailerInfo.trailerLength}}ft
              ({{request.trailerLoads[0].trailerType}})
            </span>
          </p>
}
          @if (request.trailerLoads[0].isBobtail) {
<p class="tractor-only">
            <span class="number">
              {{localize(langSection.TrailerCard, langText.TractorOnly)}}
            </span>
          </p>
}
        </div>
        <div class="destination-sort">
          @if (getLanguageCode() === 'fr') {
<div>
            <p>
              <span class="destination-organization-name" title="{{fromCustomerName}}">
                {{request.trailerLoads[0].destinationOrganizationAbbreviatedName}}
              </span>
              <span class="due-date">
                {{localize(langSection.TrailerCard, langText.Due)}} {{formattedFromDueDate}}
              </span>
            </p>
          </div>
}
          @if (getLanguageCode() !== 'fr') {
<div>
            <p>
              <span class="destination-organization-name" title="{{fromCustomerName}}">
                {{request.trailerLoads[0].destinationOrganizationAbbreviatedName}}
              </span>
              <span class="due-date">
                {{localize(langSection.TrailerCard, langText.Due)}} {{formattedFromDueDate}}
              </span>
            </p>
          </div>
}
        </div>
        <div class="sort-code">
          @if (getLanguageCode() === 'fr') {
<div>
            <span>{{localize(langSection.Term,langText.Sort)}} {{request.trailerLoads[0].destinationSortCode}}</span>
          </div>
}
          @if (getLanguageCode() !== 'fr') {
<div>
            <span>{{request.trailerLoads[0].destinationSortCode}} {{localize(langSection.Term, langText.Sort)}}</span>
          </div>
}
        </div>
        <div class="load-info position-relative">
          <span class="small percent">{{request.trailerLoads[0].percentFull}}%</span>
          <div class="long-svg"></div>
          <span class="small pieceCount">{{request.trailerLoads[0].pieceCount}}</span>
        </div>
      </div>
      <div class="bottomcols">
        <div>
          {{localize(langSection.TrailerCard, langText.Bay)}} {{request.trailerLoads[0].bayNumber}}
        </div>
        <div class="serviceLevel">
          {{
          localizeValue(langSection.ServiceLevel,
          serviceLevelTranslate[request.trailerLoads[0].serviceLevel])
          }}
        </div>
        <div class="palletcount">
          {{request.trailerLoads[0].palletCount}} {{
          localize(langSection.TrailerCard,
          langText.Pallets)
          }}
        </div>
      </div>
    </div>
  </div>
}
</div>

<div class="trailer-card break">
  @if (request.trailerLoads.length > 1 && showLoad(request.trailerLoads[1])) {
<div class="grid-container">
    <div class="direction">
      <div>{{getLoadDirection(1)}}</div>
      @if (request.trailerLoads[1].hasUnplannedLoad) {
<div class="text-warning fst-italic">
        *
        {{localize(langSection.TrailerCard, langText.NotPlanned)}}
      </div>
}
    </div>
    <div class="card" [ngClass]="{'unplanned': request.trailerLoads[1].hasUnplannedLoad, 'bobtail': request.trailerLoads[1].isBobtail}">
      <div class="topcols">
        <div class="trailer-number">
          @if (!request.trailerLoads[1].isBobtail) {
<p>
            <span class="number" [title]="request.trailerLoads[1].trailerInfo.trailerNumber">
              {{request.trailerLoads[1].trailerInfo.trailerNumber}}
            </span>
            <span class="length">
              {{request.trailerLoads[1].trailerInfo.trailerLength}}ft
              ({{request.trailerLoads[1].trailerType}})
            </span>

          </p>
}
          @if (request.trailerLoads[1].isBobtail) {
<p class="tractor-only">
            <span class="number">
              {{localize(langSection.TrailerCard, langText.TractorOnly)}}
            </span>
          </p>
}
        </div>
        <div class="destination-sort">
          @if (getLanguageCode() === 'fr') {
<div>
            <p>
              <span class="destination-organization-name" title="{{toCustomerName}}">
                {{request.trailerLoads[1].destinationOrganizationAbbreviatedName}}
              </span>
              <span class="due-date">
                {{localize(langSection.TrailerCard, langText.Due)}} {{formattedToDueDate}}
              </span>
            </p>
          </div>
}
          @if (getLanguageCode() !== 'fr') {
<div>
            <p>
              <span class="destination-organization-name" title="{{toCustomerName}}">
                {{request.trailerLoads[1].destinationOrganizationAbbreviatedName}}
              </span>
              <span class="due-date">
                {{localize(langSection.TrailerCard, langText.Due)}} {{formattedToDueDate}}
              </span>
            </p>
          </div>
}
        </div>
        <div class="sort-code">
          @if (getLanguageCode() === 'fr') {
<div>
            <span>{{localize(langSection.Term, langText.Sort)}} {{request.trailerLoads[1].destinationSortCode}}</span>
          </div>
}
          @if (getLanguageCode() !== 'fr') {
<div>
            <span>{{request.trailerLoads[1].destinationSortCode}} {{localize(langSection.Term, langText.Sort)}}</span>
          </div>
}
        </div>
        <div class="load-info position-relative">
          <span class="small percent">{{request.trailerLoads[1].percentFull}}%</span>
          <div class="long-svg"></div>
          <span class="small pieceCount">{{request.trailerLoads[1].pieceCount}}</span>
        </div>
      </div>
      <div class="bottomcols">
        <div>
          {{localize(langSection.TrailerCard, langText.Bay)}} {{request.trailerLoads[1].bayNumber}}
        </div>
        <div class="serviceLevel">
          {{
          localizeValue(langSection.ServiceLevel,
          serviceLevelTranslate[request.trailerLoads[1].serviceLevel])
          }}
        </div>
        <div class="palletcount">
          {{request.trailerLoads[1].palletCount}} {{
          localize(langSection.TrailerCard,
          langText.Pallets)
          }}
        </div>
      </div>
    </div>
  </div>
}
</div>